import { flexRender } from '@/lib/tanstack-table';
import { NeedReadOnly } from './NeedReadOnly';
import { formatUnitCost } from './unitCostFormat';
import type { LineCell, LineCellContext } from './needRowsContext';
import type { NeedGroup } from '../utils/needRows';

export function NeedUnitCostCell({
  need,
  context,
  base,
}: {
  need: NeedGroup;
  context: LineCellContext;
  base: LineCell;
}) {
  const costs = need.open.flatMap((line) =>
    line.topOption?.unitCost == null ? [] : [line.topOption.unitCost],
  );
  if (costs.length === 0 || costs.every((cost) => cost === costs[0])) {
    return <NeedReadOnly>{flexRender(base, context)}</NeedReadOnly>;
  }
  return (
    <span className="text-xs tabular-nums text-gray-500">
      {formatUnitCost(Math.min(...costs))}–{formatUnitCost(Math.max(...costs))}
    </span>
  );
}
